<div id="differently-abled" class="inner-page py-5">
  <div class="container px-lg-5">

    <!-- Header Section -->
    <div class="text-center mb-5">
      <h1 class="display-6 fw-bold text-uppercase text-orange mb-2" style="color: #f48020;">Facilities for Differently Abled</h1>
      <h4 class="fw-semibold text-dark mb-4">"Building a Barrier-Free, Inclusive and Accessible Campus"</h4>
      <p class="lead text-muted mx-auto" style="max-width: 900px; line-height: 1.8; text-align: justify;">
        Shah Satnam Ji Girls College believes that physical challenges should never limit intellectual dreams. We are committed to providing a barrier-free, supportive infrastructure that ensures easy physical accessibility and academic equality for differently-abled (Divyangjan) students.
      </p>
      <hr class="divider mx-auto" style="width: 80px; height: 3px; background: var(--primary); border: none; opacity: 1;">
    </div>

    <!-- Content Card -->
    <div class="content-card p-4 p-md-5 shadow-sm rounded-4 bg-white border-top border-5 border-success mb-5">
      
      <!-- Physical Infrastructure -->
      <h5 class="fw-bold text-success text-uppercase mb-3" style="letter-spacing: 0.5px;">Barrier-Free Campus Infrastructure</h5>
      <p class="text-muted mb-3">Our campus has been systematically designed and upgraded to enable independent and dignified mobility for students with physical disabilities:</p>
      <ul class="text-muted mb-4" style="line-height: 1.8; padding-left: 20px;">
        <li class="mb-2"><strong>Wheelchair-Accessible Ramps:</strong> Sturdy, well-angled ramps equipped with secure handrails installed at all major entrances and administrative blocks.</li>
        <li class="mb-2"><strong>Lift Facilities:</strong> Modern lifts in multi-story academic buildings to provide easy floor-to-floor transit.</li>
        <li class="mb-2"><strong>Specialized Restrooms:</strong> Specially designed, barrier-free restrooms on major floors, equipped with support bars, wider doors, and non-slip floors.</li>
        <li class="mb-2"><strong>Dedicated Signages:</strong> Clear visual signage throughout corridors, administrative spaces, and laboratories to guide students.</li>
      </ul>

      <!-- Academic Assistance -->
      <h5 class="fw-bold text-success text-uppercase mb-3" style="letter-spacing: 0.5px;">Academic Support & Special Exam Provisions</h5>
      <p class="text-muted mb-3">We ensure that no student faces an academic disadvantage due to a sensory or physical limitation:</p>
      <ul class="text-muted mb-4" style="line-height: 1.8; padding-left: 20px;">
        <li class="mb-2"><strong>Scribe & Reader Services:</strong> Provision of highly qualified scribes and readers during university examinations as per official regulatory guidelines.</li>
        <li class="mb-2"><strong>Extra Time Allotment:</strong> Extension of writing times during assessments and examinations to alleviate stress.</li>
        <li class="mb-2"><strong>Digital Library Resources:</strong> Accessibility of screen-reading software and audiobooks inside the library for visually impaired students.</li>
      </ul>

      <!-- Personalized Care -->
      <h5 class="fw-bold text-success text-uppercase mb-3" style="letter-spacing: 0.5px;">Empowerment & Support Systems</h5>
      <p class="text-muted mb-3" style="text-align: justify; line-height: 1.8;">
        The college maintains a highly empathetic environment. Faculty members are sensitized to provide additional support, flexible assignment deadlines, and personalized tutoring to ensure all differently-abled students feel highly included, valued, and motivated to excel.
      </p>

      <!-- Alert Banner -->
      <div class="p-4 rounded-4 mt-5 text-center" style="background-color: #fcece3; border: 1px solid #ffd8c3;">
        <h5 class="fw-bold mb-2" style="color: #e06c00;">"The only disability in life is a bad attitude."</h5>
        <p class="mb-0 fw-semibold text-muted" style="font-size: 15px;">Our support committee stands ready to assist with custom requests, wheelchairs, or academic adjustments.</p>
      </div>

    </div>

  </div>
</div>
